
import { trackContact } from '@/core/services/tracking-service'
import { PolygonEmployee } from '@/types/api/polygon-employee'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    contact: {
      required: true,
      type: Object as PropType<PolygonEmployee>
    },
    contactType: { type: String as PropType<'technician' | 'project_manager'>, required: false, default: 'project_manager' }
  },
  setup() {
    return {
      trackContact
    }
  }
})
